module.exports = __webpack_public_path__ + "docs/assets/fonts/Roboto-MediumItalic-c16d19c2c0fd1278390a82fc245f4923.ttf";